<!--  -->
<template>
  <div class="tablwbox">
    <div class="srrwrw search_box">
      <el-select v-model="paquery.platform_id" style=" margin-top:5px" filterable placeholder="请选择平台">
        <el-option
          v-for="item in accoutarr"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select v-model="paquery.subscribe_status" style=" margin-top:5px" filterable placeholder="请选择状态">
        <el-option
          v-for="item in [{id:1, name: '未知'}, {id: 2, name: '关注'}, {id:3 , name: '取消关注'}]"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-input v-model="paquery.nickName" placeholder="用户昵称" style=" margin-top:5px;width:200px" />
      <el-input v-model="paquery.bind_seller" placeholder="绑定销售名称（精准）" style=" margin-top:5px;width:200px" />
      <el-input v-model="paquery.account_name" placeholder="公众号名称" style=" margin-top:5px;width:200px" />
      <el-select v-model="paquery.bind_status" style=" margin-top:5px" filterable placeholder="是否加入个微">
        <el-option
          v-for="item in [{id:0, name: '全部'},{id:1, name: '是'}, {id: 2, name: '否'}]"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-date-picker
        v-model="subscribe_timewe"
        style=" margin-top:5px"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="tiwmew"
      />
      <el-input v-model="paquery.keyword" placeholder="openid/appid/gh_id" style="width:200px" />
      <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="srarch">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="reset">重置</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <!-- <el-table-column
        prop="platform_id"
        label="用户平台ID"
        width="50"
        align="center"
      /> -->
      <el-table-column
        prop="open_id"
        label="openId"
        width="160"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="appId"
        width="160"
        align="center"
      />
      <el-table-column
        prop="platform_name"
        label="平台名"
        width="100"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="公众号"
        width="130"
        align="center"
      />
      <el-table-column
        prop="subscribe_scene"
        label="用户关注的渠道来源"
        width="150"
        align="center"
      />
      <el-table-column
        prop="nickname"
        label="昵称"
        width="100"
        align="center"
      />
      <el-table-column
        prop="head_portrait"
        label="头像"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <img v-if="scope.row.head_portrait" :src="scope.row.head_portrait" alt="" style="width:80px;height:80px">
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="150"
        align="center"
      />
      <el-table-column
        prop="subscribe_time_text"
        label="用户关注时间"
        width="150"
        align="center"
      />
      <el-table-column
        prop="interaction_time_text"
        label="互动时间"
        width="150"
        align="center"
      />
      <el-table-column
        prop="cancel_subscribe_time_text"
        label="取消关注时间"
        width="150"
        align="center"
      />
      <el-table-column
        prop="register_time_text"
        label="用户注册时间"
        width="150"
        align="center"
      />
      <el-table-column
        prop="subscribe_status_text"
        label="关注状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.subscribe_status == 2" class="el-icon-success defaultr" />
          <i v-if="scope.row.subscribe_status == 1" class="el-icon-warning" />
          <i v-if="scope.row.subscribe_status == 3" class="el-icon-error stopew" />
          {{ scope.row.subscribe_status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="sale_name"
        label="销售名称"
        width="100"
        align="center"
      />
      <el-table-column
        prop="order_total"
        label="订单总额"
        width="100"
        align="center"
      />
      <el-table-column
        prop="last_order_pay_time"
        label="最近一笔订单支付时间"
        width="150"
        align="center"
      />
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import { operatelist, strategyPlatform } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      paquery: {
        page: 1,
        page_size: 10,
        keyword: null,
        platform_id: null, // 平台id
        subscribe_status: null, // 关注状态  1 未知 2 关注 3取消关注
        nickName: null, // 用户名称
        bind_seller: null,
        account_name: null,
        bind_status: 0,
        subscribe_time: []
      },
      total: null,
      tableData: [],
      accoutarr: [], // 平台
      subscribe_timewe: []
    }
  },
  created() {
    // this.sawrlist()
    this.getstrategyplatform()
  },
  mounted() {

  },
  methods: {
    // 获取平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = data.data.list
    },
    async sawrlist() {
      const data = await operatelist(this.paquery)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    fetchPageSizeone(e) {
      this.paquery.page_size = e
      this.sawrlist()
    },
    fetchCurrentPageone(e) {
      this.paquery.page = e
      this.sawrlist()
    },
    srarch() {
      this.paquery.page = 1
      this.sawrlist()
    },
    tiwmew(val) {
      console.log('val', val, this.subscribe_timewe)
      // if (!val) {
      //   // this.time为绑定的数据
      //   this.parameter.subscribe_time = []
      // }
      this.paquery.subscribe_time = this.subscribe_timewe
      console.log('subscribe_time', this.paquery.subscribe_time)
    },
    reset() {
      this.paquery.page = 1
      this.paquery.page_size = 10
      this.paquery.platform_id = null
      this.paquery.keyword = null
      this.paquery.subscribe_status = null
      this.paquery.nickName = null
      this.paquery.bind_seller = null
      this.paquery.account_name = null
      this.paquery.bind_status = 0
      this.paquery.subscribe_time = []
      this.subscribe_timewe = []
      this.sawrlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tablwbox{
  padding: 20px;
}
.srrwrw{
  margin-bottom: 10px;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
</style>
